import _ from 'lodash'

export const availableCaseTypesByValue = state => {
    return _.keyBy(state.availableCaseTypes, 'value')
}